import React, { useEffect, useState } from "react";
import { httpReauest } from "../utils/httpRequest";
import { Link, useNavigate } from "react-router-dom";
import { Add, ArrowLeft, User } from "iconsax-reactjs";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../components/common/LoadingSpinner";
import {
  FaTelegramPlane,
  FaWhatsapp,
  FaSms,
  FaWhatsappSquare,
  FaTelegram,
} from "react-icons/fa";

const FriendsPage = () => {
  const [loading, setLoading] = useState(true);
  const [friends, setFriends] = useState([]);
  const [invites, setInvites] = useState([]);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [inviteValue, setInviteValue] = useState("");
  const [pendingTasks, setPendingTasks] = useState([]);
  const [inviteLink, setinviteLink] = useState();

  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user);
    if (!user) {
      navigate("/login");
    } else {
      setinviteLink(`${window.location.origin}/login?refCode=${user?.refCode}`);
      fetchFriends(user._id, user.token);
      fetchPendingTasks(user._id, user.token);
    }
  }, []);

  const fetchPendingTasks = async (userId, token) => {
    try {
      const res = await httpReauest(
        "GET",
        `/task/pending/${userId}`,
        {},
        { "x-access-token": token }
      );
      setPendingTasks(res.data.data || []);
    } catch (error) {
      console.error("Error fetching pending tasks:", error);
    }
  };

  const fetchFriends = async (userId, token) => {
    try {
      const res = await httpReauest(
        "GET",
        `/user/friends/${userId}`,
        {},
        { "x-access-token": token }
      );
      const res2 = await httpReauest(
        "GET",
        `/user/friends/invite/${userId}`,
        {},
        { "x-access-token": token }
      );
      setFriends(res.data.data || []);
      setInvites(res2.data.data || []);
    } catch (error) {
      console.error("Error fetching friends:", error);
      toast.error(t("error_loading_friends"));
    } finally {
      setLoading(false);
    }
  };

  const sendInvite = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await httpReauest(
        "POST",
        `/user/add/friend`,
        { friend: inviteValue },
        { "x-access-token": user?.token }
      );
      toast.success(t("invite_sent"));
      setInviteValue("");
      setShowInviteModal(false);
      fetchFriends(user._id, user.token);
    } catch (error) {
      toast.error(t("invite_failed"));
    }
  };

  const handleAccept = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await httpReauest(
        "POST",
        `/user/accept/friend`,
        { friendId: id },
        { "x-access-token": user?.token }
      );
      fetchFriends(user._id, user.token);
    } catch (error) {
      toast.error(t("error_accepting_invite"));
    }
  };

  const handleReject = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await httpReauest(
        "DELETE",
        `/user/accept/friend`,
        { friendId: id },
        { "x-access-token": user?.token }
      );
      fetchFriends(user._id, user.token);
    } catch (error) {
      toast.error(t("error_rejecting_invite"));
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen px-4 py-6 ">
      <div className="flex justify-between items-center mb-6">
        <Link to="/profile">
          <ArrowLeft />
        </Link>
        <button
          onClick={() => setShowInviteModal(true)}
          className="flex items-center gap-2 text-blue-600"
        >
          <Add />
          {t("send_invite")}
        </button>
      </div>

      {/* Friends List */}
      <div className="mb-8">
        <h2 className="text-lg font-semibold mb-3">{t("friends")}</h2>
        {friends.length > 0 ? (
          friends.map((friend) => (
            <div
              key={friend._id}
              className="p-3 bg-white rounded shadow mb-2 flex items-center gap-2"
            >
              <User />
              <span>
                <h4 className="font-bold">{friend?.friendId?.name}</h4>
                <p className="text-[14px]">
                  {friend?.friendId?.email || friend?.friendId?.phone}
                </p>
              </span>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500">{t("no_friends")}</p>
        )}
      </div>

      {/* Invite Modal */}
      {showInviteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-4">{t("send_invite")}</h3>
            <input
              type="text"
              placeholder={t("enter_email_or_phone")}
              value={inviteValue}
              onChange={(e) => setInviteValue(e.target.value)}
              className="w-full p-2 border rounded mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowInviteModal(false)}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                {t("cancel")}
              </button>
              <button
                onClick={sendInvite}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                {t("submit")}
              </button>
            </div>

            {/* اشتراک‌گذاری با آیکون‌ها */}
            {inviteLink && (
              <div className="flex justify-center gap-4 mt-5">
                <a
                  href={`https://t.me/share/url?url=${encodeURIComponent(
                    inviteLink
                  )}&text=${encodeURIComponent(
                    "Do you want to join me on this platform?"
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 text-3xl"
                >
                  <FaTelegram />
                </a>
                <a
                  href={`https://wa.me/?text=${encodeURIComponent(
                    "Join me on this platform: " + inviteLink
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-green-500 text-3xl  overflow-hidden"
                >
                  <FaWhatsappSquare />
                </a>
                <a
                  href={`sms:?body=${encodeURIComponent(
                    "Join me on this platform: " + inviteLink
                  )}`}
                  className="text-orange-500 text-3xl"
                >
                  <FaSms />
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FriendsPage;
